import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, input, OnInit} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors
} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {ResearchPaperManuelScreeningDTO} from '../../dto/research-paper';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {Store} from '@ngrx/store';
import {
  createManuelScreeningResearchPaper,
  updateManuelScreeningResearchPaper
} from '../../services/research-paper/research-paper.actions';
import {ScreeningProcessDTO} from '../../dto/screening-process';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {SaveBtnComponent} from '../../../../utils/components/save-btn/save-btn.component';

@Component({
  selector: 'app-research-paper-override-screening',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    SaveBtnComponent
  ],
  templateUrl: './research-paper-override-screening.component.html',
  styleUrl: './research-paper-override-screening.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResearchPaperOverrideScreeningComponent implements OnInit {
  private formBuilder: FormBuilder = inject(FormBuilder);
  private readonly store: Store = inject(Store);
  private readonly cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  readonly isNew = input<boolean>(false);
  readonly paperId = input.required<number>();
  readonly process = input.required<ScreeningProcessDTO>();
  readonly projectId = input.required<number>();
  readonly editable = input<boolean>(true);

  formGroup = this.formBuilder.group({
    reason: ['', this.reasonValidator.bind(this)],
    passedOne: [true],
    passedTwo: [true]
  });


  ngOnInit(): void {
    if (!this.isNew() && this.process()) {
      this.formGroup.patchValue({
        passedOne: this.process().manuelOverrideScreeningOne,
        passedTwo: this.process().manuelOverrideScreeningTwo,
        reason: this.process().screeningOverrideReason,
      });
    }
    if (!this.editable()) {
      this.formGroup.disable()
    }
    this.cdr.detectChanges();
  }


  reasonValidator(formGroup: FormGroup) {
    return (control: AbstractControl): ValidationErrors | null => {
      const passed = formGroup.get('passed')?.value;
      if (passed && !control.value) {
        return {required: true};
      }
      return null;
    };
  }

  save(formGroup: FormGroup) {
    if (formGroup.invalid) {
      return;
    }
    const createDTO: ResearchPaperManuelScreeningDTO = {...formGroup.value};
    if (this.isNew()) {
      this.store.dispatch(() => createManuelScreeningResearchPaper({
        projectId: this.projectId(),
        paperId: this.paperId(),
        result: createDTO
      }));
    } else {
      this.store.dispatch(() => updateManuelScreeningResearchPaper({
        projectId: this.projectId(),
        paperId: this.paperId(),
        processId: this.process().id,
        result: createDTO
      }));
    }

  }

}
